<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.mst.company.title.list') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="3" class="py-0">
        <mp-button min wide @click="goAdd">会社追加</mp-button>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h2>検索条件</h2>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="6" md="3">
        <mp-label>グループ分類</mp-label>
      </v-col>
      <v-col cols="6" md="3" outlined tile>
        <mp-input-box min>
          <v-select
            v-model="form.groupSmallId"
            :items="view.groupList"
            item-text="text"
            item-value="value"
            label="選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
          ></v-select>
        </mp-input-box>
      </v-col>
      <v-col cols="6" md="3">
        <mp-label>会社名</mp-label>
      </v-col>
      <v-col cols="6" md="3" outlined tile>
        <mp-input-box min>
          <v-text-field
            v-model="form.companyName"
            hide-details
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="6" md="2" class="py-1">
        <mp-button min wide @click="goSearch">検索</mp-button>
      </v-col>
    </v-row>

    <template v-if="search.show && search.list.length > 0">
      <v-row class="mt-5">
        <v-col cols="12" class="py-0">
          <div class="text-right ma-0 py-0 list-count">一覧件数：{{ search.list.length | addComma }}件</div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="search.list"
            item-key="companyId"
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            height="400"
            fixed-header
            mobile-breakpoint=0
            hide-default-footer
            class="elevation-1"
            :page.sync="search.paging.page"
            :items-per-page="search.paging.itemsPerPage"
            @page-count="search.paging.pageCount = $event"
          >
            <template v-slot:item="{ item }">
                <tr>
                  <td><router-link :to="`/admin/mst/company/detail/${item.companyId}`">{{ item.companyName }}</router-link></td>
                  <td>{{ item.groupLargeNameJp }}＞{{ item.groupSmallNameJp }}</td>
                  <td align="center">{{ item.displayOrder }}</td>
                  <td align="center">{{ item.branchCount | addComma }}</td>
                  <td align="center">{{ item.accountCount | addComma }}</td>
                  <td align="center">{{ item.accountEntryCount | addComma }}</td>
                </tr>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination color="#0F9956" circle v-model="search.paging.page"
                          :length="search.paging.pageCount"></v-pagination>
          </div>
        </v-col>
      </v-row>
    </template>

    <template v-else-if="search.show && search.list.length === 0">
      <v-row justify="center">
        <v-col cols="12" class="pt-0">
          <div>
            検索条件に該当する会社は、ありません。
          </div>
        </v-col>
      </v-row>
    </template>

  </v-container>
</template>

<script>
// import i18n from '@/message'
import { Common, AdminMstCompany } from '@/api'
import MpLabel from '@/components/item/MpLabel'
import MpInputBox from '@/components/item/MpInputBox'
import MpButton from '@/components/item/MpButton'

export default {
  name: 'AdminMstCompanyList',
  components: {
    MpLabel,
    MpButton,
    MpInputBox
  },
  data: () => ({
    view: {
      groupList: []
    },
    form: {
      groupSmallId: null,
      companyName: ''
    },
    search: {
      show: false,
      list: [],
      paging: {
        page: 1,
        pageCount: 5,
        itemsPerPage: 50
      }
    },
    headers: [
      { text: '会社名', value: 'companyName', sortable: false },
      { text: '分類', value: 'groupName', sortable: false, width: 200 },
      { text: '表示順', value: 'displayOrder', align: 'center', sortable: false, width: 80 },
      { text: '支社・支局／媒体数', value: 'branchCount', align: 'center', sortable: false, width: 150 },
      { text: 'アカウント数', value: 'accountCount', align: 'center', sortable: false, width: 150 },
      { text: 'アカウント申請数', value: 'accountEntryCount', align: 'center', sortable: false, width: 150 }
    ]
  }),
  methods: {
    async goSearch () {
      this.search.list = await AdminMstCompany.search(this.form)
      await this.$store.dispatch('formAdminMstCompanyList', this.form)
      this.search.show = true
    },
    goAdd () {
      this.$router.push({ path: '/admin/mst/company/add' })
    },
    async restResult () {
      if (this.$store.state.form.adminMstCompanyList !== undefined) {
        this.form = this.$store.state.form.adminMstCompanyList
        await this.goSearch()
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(async function (vm) {
      // 詳細からの遷移時は、元の検索結果を表示させる。
      if (from.name === 'AdminMstCompanyDetail' || from.name === 'AdminMstCompanyAdd') {
        await vm.restResult()
      } else {
        await vm.$store.dispatch('formAdminMstCompanyList', undefined)
      }
    })
  },
  created: async function () {
    this.view.groupList = (await Common.groupList())
      .filter(groupLarge => groupLarge.companyInsNoFlg === '0')
      .flatMap(groupLarge => groupLarge.groupSmallList
        .map(groupSmall => ({
          text: groupLarge.groupLargeName.ja + '＞' + groupSmall.groupSmallName.ja,
          value: groupSmall.groupSmallId
        })))
    this.view.groupList.unshift({ text: '----', value: '' })
  }
}
</script>
